import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderColor: (p) => p.palette.primary[200],
};

export const item: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: (p) => p.spacing(1.5, 2),
};

export const divider: SxStyle = {
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[200],
};
